/* eslint-disable react/no-array-index-key */
/* eslint-disable no-plusplus */
/* eslint-disable implicit-arrow-linebreak */
import React, { useEffect, useState } from 'react';

import ReactModal from 'react-modal';
import closeSvg from 'src/assets/close.svg';
import { useTranslation } from 'react-i18next';
import {
  CloseIcon,
  Content,
  FormTitle,
  Header,
  FormRow,
  ModalContent,
  EyeIcon,
  DocumentRow,
  IconsSlot,
} from './styles';

export const ReviewDocumentsModal: React.FC<{
  isOpen: boolean;
  documents: { name: string; url: string }[];
  onClose: () => void;
}> = ({ isOpen, documents, onClose }) => {
  const [modalIsOpen, setIsOpen] = useState<boolean>(isOpen);

  // eslint-disable-next-line no-unused-vars
  const { t } = useTranslation();

  useEffect(() => {
    setIsOpen(isOpen);
  }, [isOpen]);

  const handleModal = () => {
    setIsOpen(prevIsOpen => !prevIsOpen);
    if (isOpen) {
      onClose();
    }
  };

  const openFilePreview = (name: string, url: string) => {
    const link = document.createElement('a');
    link.target = '_blank';
    link.href = url;
    link.download = name;
    link.click();
  };

  return (
    <ReactModal
      isOpen={modalIsOpen}
      ariaHideApp={false}
      onRequestClose={handleModal}
      style={{
        overlay: {
          margin: 'auto',
          backgroundColor: 'rgba(0, 0, 0, 0.6)',
        },
        content: {
          borderRadius: '30px',
          margin: 'auto',
          width: '696px',
          height: '290px',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          padding: '0 40px 0 40px',
          overflowY: 'hidden',
        },
      }}
    >
      <Header>
        <FormTitle>{t('employeeReviewChanges.documentsReviewModal.title')}</FormTitle>
        <CloseIcon src={closeSvg} onClick={() => handleModal()} />
      </Header>

      <Content>
        <ModalContent>
          <FormRow>
            {documents.map((doc: { name: string; url: string }, index: number) => (
              <DocumentRow stripped={index % 2 > 0} key={index}>
                {doc.name}
                <IconsSlot>
                  <EyeIcon onClick={() => openFilePreview(doc.name, doc.url)} />
                </IconsSlot>
              </DocumentRow>
            ))}
          </FormRow>
        </ModalContent>
      </Content>
    </ReactModal>
  );
};
